export class AddNewFeedback{
    static readonly type = '[ADD NEW FEEDBACK] Add New Feedback';
    constructor(public payload: any) {}
}